
export class CommisionStrategyManager {
  strategy = null;

  constructor() {
    this.strategy = null;
  }

  get strategy() {
    return this.strategy;
  }

  set strategy(value) {
    this.strategy = value;
  }

  calculateCommission(obj, rootState, rootGetters) {
    return this.strategy.calculateCommission(obj, rootState, rootGetters);
  }
}
